import { FilterState } from "../../classes/filter-state";
import { IEvent } from "../../interfaces";
import { hashFilters } from "../../helpers/hash-filters";

/**
 * Interface to define the Filter state of the calendar.
 */
export interface ICalendarFilterState<T extends IEvent> {
    filterHash: number;
    filtersDialogOpen: boolean;
    venueFilter: FilterState<T>;
    availabilityFilter: FilterState<T>;
    genreFilter: FilterState<T>;
    typeFilter: FilterState<T>;
}

const venueFilter = new FilterState<IEvent>('location', true);
const availabilityFilter = new FilterState<IEvent>('discountTags', true);
const genreFilter = new FilterState<IEvent>('categories', true);
const typeFilter = new FilterState<IEvent>('type');

const filterHash = hashFilters(venueFilter, availabilityFilter, genreFilter, typeFilter);

export const defaultCalendarFiltersState: ICalendarFilterState<IEvent> = {
    filterHash,
    filtersDialogOpen: false,
    venueFilter,
    availabilityFilter,
    genreFilter,
    typeFilter
}
